<template>
    <iq-card class="ml-3 mr-3">
       <template v-slot:headerTitle>
          <h4 class="card-title">Invoice Request Form</h4>
       </template>
       <template v-slot:default>
          <form>
             <b-row>
                <b-col lg="12">
                   <div class="iq-edit-list-data">
          <Form @submit="onSubmit" v-slot="{ errors }" :validation-schema="rules">
          <div class="form-group row align-items-center">
          <b-col md="12">
          </b-col>
          </div>
          <div class="row">
          <div class="form-group col-md-6">
          <label for="firstName">First Name</label>
          <Field name="firstName" class="form-control mb-0" :class="{ 'is-invalid': errors['firstName']}"
             id="firstName"/>
          </div>
          <div class="form-group col-md-6">
          <label for="lastName">Last Name</label>
          <Field name="lastName" class="form-control mb-0" :class="{ 'is-invalid': errors['lastName']}"
             id="lastName"/>
          </div>
          </div>
          <div class="row">
          <div class="form-group col-md-6">
          <label for="email">Email</label>
          <Field name="email" class="form-control mb-0" :class="{ 'is-invalid': errors['email']}"
             id="email"/>
          </div>
          <div class="form-group col-md-6">
          <label for="phone">Phone</label>
          <Field name="phone" class="form-control mb-0" :class="{ 'is-invalid': errors['phone']}"
             id="phone"/>
          </div>
          </div>
          <div class="row">
          <div class="form-group col-md-12">
          <label for="occupation">Occupation</label>
          <Field name="occupation" class="form-control mb-0" :class="{ 'is-invalid': errors['occupation']}"
             id="occupation"/>
          </div>
          </div>
          <div class="row">
          <div class="form-group col-md-12 mb-0">
          <label for="address1">Address</label>
          <Field name="address1" class="form-control mb-0" :class="{ 'is-invalid': errors['address1']}"
             id="address1" type="text"/>
          <span class="form-sub">Street address</span>
          </div>
          <div class="form-group col-md-12 mb-0">
          <Field name="address2" class="form-control mb-0"
             id="address2" type="text"/>
          <span class="form-sub">Street address line 2</span>
          </div>
          </div>
          <div class="row">
          <div class="form-group col-md-6 mb-0">
          <Field name="city" class="form-control mb-0" :class="{ 'is-invalid': errors['city']}"
             id="city" type="text"/>
          <span class="form-sub">City</span>
          </div>
          <div class="form-group col-md-6 mb-0">
          <Field name="province" class="form-control mb-0" :class="{ 'is-invalid': errors['province']}"
             id="province" type="text"/>
          <span class="form-sub">Province</span>
          </div>
          </div>
          <div class="row">
          <div class="form-group col-md-6">
          <Field name="postalCode" class="form-control mb-0" :class="{ 'is-invalid': errors['postalCode']}"
             id="postalCode" type="text"/>
          <span class="form-sub">Postal Code</span>
          </div>
          <div class="form-group col-md-6">
          <Field name="country" class="form-control mb-0" :class="{ 'is-invalid': errors['country']}"
             id="country" type="text"/>
          <span class="form-sub">Country</span>
          </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12">
                <label for="size">Size</label>
                <div>
                <Field name="size" type="radio" value="S"/> S
                <Field class="ml-2" name="size" type="radio" value="M" /> M
                <Field class="ml-2" name="size" type="radio" value="L" /> L
                <Field class="ml-2" name="size" type="radio" value="XL" /> XL
                </div>
            </div>
            </div>
        <div class="row">
          <div class="form-group col-md-12">
          <label for="purpose">Purpose</label>
          <Field name="purpose" class="form-control mb-0" :class="{ 'is-invalid': errors['purpose']}"
             id="purpose"/>
          </div>
          </div>
          <div class="row">
          <div class="form-group col-md-12">
          <label for="details">Request details</label>
          <Field name="details" class="form-control mb-0" :class="{ 'is-invalid': errors['details']}"
             id="details" as="textarea"/>
          </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12">
                <label for="how">How did you hear about us</label>
                <div>
                <Field name="how" type="checkbox" value="Social media"/> Social media
                <Field class="ml-2" name="how" type="checkbox" value="Peer referal" /> Peer referal
                <Field class="ml-2" name="how" type="checkbox" value="Google" /> Google
                <Field class="ml-2" name="how" type="checkbox" value="Other" /> Other
                </div>
            </div>
            </div>
          <b-button v-if="!loading" type="submit" variant="primary" class="mr-2 ml-3 mb-3">Request invoice</b-button>
          <b-button v-else disabled variant="primary" class="mr-2 ml-3">Sending request</b-button>
          <div role="alert" class="alert alert-success ml-3" v-if="success">
            <div class="iq-alert-text">Thank you for your request. We will be in touch shortly.</div>
          </div>
          </Form>
          </div>
          </b-col>
          </b-row>
          </form>
       </template>
    </iq-card>
 </template>
<script>
import IqCard from '../../components/xray/cards/iq-card'
import { xray } from '../../config/pluginInit'
import { ref } from 'vue'
import emailjs from '@emailjs/browser'
import firebase from '../../../firebase'
import { Field, Form } from 'vee-validate'
import * as yup from 'yup'
import useCollection from '../../services/useCollection'

const body = document.getElementsByTagName('body')

export default {
  name: 'InvoiceRequestForm',
  components: { IqCard, Field, Form },
  setup () {
    const loading = ref(false)
    const success = ref(false)
    const formRef = ref(null)
    const { addDocToDb } = useCollection('invoiceRequests')

    emailjs.init('LvSuysay9DKfGKIZP')

    const rules = yup.object().shape({
      firstName: yup.string().required(),
      lastName: yup.string().required(),
      email: yup.string().email().required(),
      address1: yup.string().required(),
      city: yup.string().required(),
      province: yup.string().required(),
      postalCode: yup.number().required(),
      country: yup.string().required(),
      details: yup.string().required(),
      size: yup.string().required(),
      phone: yup.number().required(),
      purpose: yup.string().required(),
      occupation: yup.string().required(),
      how: yup.array().required()
    })

    const onSubmit = async (form, { resetForm }) => {
      loading.value = true
      success.value = false
      const templateParams = {
        firstName: form.firstName,
        lastName: form.lastName,
        email: form.email,
        details: form.details,
        uid: firebase.firebaseAuth.currentUser.uid,
        size: form.size,
        phone: form.phone,
        purpose: form.purpose,
        occupation: form.occupation,
        how: form.how
      }

      templateParams.address = form.address2
        ? `${form.address1} ${form.address2}, ${form.city},
            ${form.province} ${form.postalCode}, ${form.country}`
        : `${form.address1}, ${form.city},
            ${form.province} ${form.postalCode}, ${form.country}`

      try {
        await Promise.all([
          emailjs.send('service_3sv7nm7', 'template_s3s3liw', templateParams),
          addDocToDb({
            ...templateParams,
            date: new Date().toDateString()
          })])
        loading.value = false
        success.value = true
        resetForm()
      } catch (e) {
        console.log(e)
      }
    }

    return {
      rules,
      onSubmit,
      loading,
      success,
      formRef
    }
  },
  mounted () {
    xray.index()
    body[0].classList.add('sidebar-main-menu')
  },
  unmounted () {
    body[0].classList.remove('sidebar-main-menu')
  }
}
</script>

<style scoped>
.form-sub {
    margin: 0;
    font-size: 12px;
}

label::before {
  content: "* ";
  color: red;
}
</style>
